import {Button, Checkbox, Flex, FormControl, SimpleGrid} from "@chakra-ui/react";
import React, {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {ROUTES} from "../../../../constants/routes-path";

function BoatAccidentForm({onSubmit, values}) {

    const {t} = useTranslation();
    const navigate = useNavigate();

    const ids = useMemo(() => ({
        atropelamento: "atropelamento",
        capotamento: "capotamento",
        choque: "choque",
        colisaoFrontal: "colisaoFrontal",
        colisaoLateral: "colisaoLateral",
        colisaoPosterior: "colisaoPosterior",
        colisaoTransversal: "colisaoTransversal",
        outros: "outros",
    }), []);

    const initFormData = (data) => {
        return {
            [ids.atropelamento]: data?.atropelamento || false,
            [ids.capotamento]: data?.capotamento || false,
            [ids.choque]: data?.choque || false,
            [ids.colisaoFrontal]: data?.colisaoFrontal || false,
            [ids.colisaoLateral]: data?.colisaoLateral || false,
            [ids.colisaoPosterior]: data?.colisaoPosterior || false,
            [ids.colisaoTransversal]: data?.colisaoTransversal || false,
            [ids.outros]: data?.outros || false
        }
    };

    const [formData, setFormData] = useState(initFormData(values));

    const handleInputChange = (e) => {
        const id = e.target.id;
        const value = e.target.checked;

        const newFormData = {...formData, [id]: value};
        setFormData(newFormData);
    };

    const handleOnSubmit = () => {
        onSubmit(formData);
    }

    const saveDraft = () => {
        onSubmit(formData, true)
    }

    return (
      <>
          <SimpleGrid spacing={2} columns={{sm: 1, md: 4}}>
              <FormControl>
                  <Checkbox
                      isChecked={formData[ids.atropelamento]}
                      id={ids.atropelamento}
                      onChange={handleInputChange}
                      colorScheme="blue"
                  >
                      {t("boat.new.accident.run-over")}
                  </Checkbox>
              </FormControl>
              <FormControl>
                  <Checkbox
                      isChecked={formData[ids.capotamento]}
                      id={ids.capotamento}
                      onChange={handleInputChange}
                      colorScheme="blue"
                  >
                      {t("boat.new.accident.rollover")}
                  </Checkbox>
              </FormControl>
              <FormControl>
                  <Checkbox
                      isChecked={formData[ids.choque]}
                      id={ids.choque}
                      onChange={handleInputChange}
                      colorScheme="blue"
                  >
                      {t("boat.new.accident.crash")}
                  </Checkbox>
              </FormControl>
              <FormControl>
                  <Checkbox
                      isChecked={formData[ids.colisaoFrontal]}
                      id={ids.colisaoFrontal}
                      onChange={handleInputChange}
                      colorScheme="blue"
                  >
                      {t("boat.new.accident.front-collision")}
                  </Checkbox>
              </FormControl>
              <FormControl>
                  <Checkbox
                      isChecked={formData[ids.colisaoLateral]}
                      id={ids.colisaoLateral}
                      onChange={handleInputChange}
                      colorScheme="blue"
                  >
                      {t("boat.new.accident.side-collision")}
                  </Checkbox>
              </FormControl>
              <FormControl>
                  <Checkbox
                      isChecked={formData[ids.colisaoPosterior]}
                      id={ids.colisaoPosterior}
                      onChange={handleInputChange}
                      colorScheme="blue"
                  >
                      {t("boat.new.accident.subsequent-collision")}
                  </Checkbox>
              </FormControl>
              <FormControl>
                  <Checkbox
                      isChecked={formData[ids.colisaoTransversal]}
                      id={ids.colisaoTransversal}
                      onChange={handleInputChange}
                      colorScheme="blue"
                  >
                      {t("boat.new.accident.transverse-collision")}
                  </Checkbox>
              </FormControl>
              <FormControl>
                  <Checkbox
                      isChecked={formData[ids.outros]}
                      id={ids.outros}
                      onChange={handleInputChange}
                      colorScheme="blue"
                  >
                      {t("boat.new.others")}
                  </Checkbox>
              </FormControl>
          </SimpleGrid>

          <Flex w="100%" justify="space-between" mt="20px">
              <Button
                  variant="light"
                  fontSize="sm"
                  w="125px"
                  onClick={() => navigate(ROUTES.boatsPath)}
              >
                  {t("system.actions.cancel")}
              </Button>
              <Flex>
                  <Button
                      w="150px"
                      variant="solid"
                      fontSize="sm"
                      mr="10px"
                      onClick={saveDraft}
                  >
                      {t('boat.actions.draft')}
                  </Button>
                  <Button
                      w="125px"
                      variant="dark"
                      fontSize="sm"
                      onClick={handleOnSubmit}
                  >
                      {t('system.actions.next')}
                  </Button>
              </Flex>
          </Flex>
      </>
    );
}

export default BoatAccidentForm;